import React from 'react';
import Header from './Header';
import ComparisonSectionEnhanced from './ComparisonSectionEnhanced';
import Footer from './Footer';
import './ComparisonPage.css';

const ComparisonPage = () => {
  return (
    <div className="comparison-page">
      <Header />
      <main className="comparison-main">
        {/* Hero Section */}
        <section className="comparison-hero">
          <div className="hero-overlay"></div>
          <div className="hero-content">
            <h1>Comparaison de Produits</h1>
            <p>Comparez les caractéristiques de nos produits pour faire le meilleur choix</p>
          </div>
        </section>
        
        {/* Comparison Section */}
        <div className="container">
          <ComparisonSectionEnhanced />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ComparisonPage;
